/* eslint-disable */
export default function letterIndex() {
    const letters = document.querySelectorAll('.js-letters-letter');
    if (letters.length < 1) {
        return;
    }

    let lettersPage = 1;

    function toggleLetterIndex(event, listSearchbar, letterIndex, closeLetterIndex) {
        event.preventDefault();
        listSearchbar?.classList.toggle('open');
        letterIndex?.classList.toggle('show');
        closeLetterIndex?.classList.toggle('show');
    }

    function initLetterIndexDropdown() {
        const letterIndexButton = document.querySelector('.js-letter-index-button');
        if (!letterIndexButton) {
            return;
        }

        const listSearchbar = document.querySelector('.js-list-search-bar');
        const letterIndex = document.querySelector('.js-letter-index-list');
        const closeLetterIndex = document.querySelector('.js-letter-index-close');
        letterIndexButton?.addEventListener('click', (event) => toggleLetterIndex(event, listSearchbar, letterIndex, closeLetterIndex));
    }

    function changeLettersInLetterIndexNav(allLetters) {
        let nextLetters = [];

        switch (lettersPage) {
            case 1:
                nextLetters = allLetters.slice(0, 10);
                break;
            case 2:
                nextLetters = allLetters.slice(10, 20);
                break;
            case 3:
                nextLetters = allLetters.slice(20, 27);
                break;
            default:
                return;
        }

        allLetters.forEach((element) => {
            element.style.display = 'none';
        });

        nextLetters.forEach((element) => {
            element.style.display = 'flex';
        });
    }

    function updateArrowsInLetterIndexNav(lettersPrev, lettersNext) {
        if (lettersPage !== 1) {
            lettersPrev?.classList.remove('is-disabled', 'is-nonclickable');
        } else {
            lettersPrev?.classList.add('is-disabled', 'is-nonclickable');
        }

        if (lettersPage === 3) {
            lettersNext?.classList.add('is-disabled', 'is-nonclickable');
        } else {
            lettersNext?.classList.remove('is-disabled', 'is-nonclickable');
        }
    }

    function toggleLetterIndexNext(lettersCurrentPage, lettersPrev, lettersNext, allLetters) {
        if (lettersPage >= 3) {
            return;
        }

        lettersPage += 1;
        changeLettersInLetterIndexNav(allLetters);
        updateArrowsInLetterIndexNav(lettersPrev, lettersNext);

        if (lettersCurrentPage) {
            lettersCurrentPage.innerHTML = `${lettersPage}/3`;
        }
    }

    function toggleLetterIndexPrev(lettersCurrentPage, lettersPrev, lettersNext, allLetters) {
        if (lettersPage <= 1) {
            return;
        }

        lettersPage -= 1;
        changeLettersInLetterIndexNav(allLetters);
        updateArrowsInLetterIndexNav(lettersPrev, lettersNext);

        if (lettersCurrentPage) {
            lettersCurrentPage.innerHTML = `${lettersPage}/3`;
        }
    }

    function toggleLetterIndexLayout(allLetters) {
        if (window.matchMedia('(min-width: 1044px), (max-width: 576px)').matches) {
            allLetters.forEach((element) => element.style.display = 'flex');
        } else {
            changeLettersInLetterIndexNav(allLetters);
        }
    }

    function initLetterIndexNavigation() {
        const allLetters = Array.prototype.slice.call(letters);
        const lettersNext = document.querySelector('.js-letters-next');
        const lettersPrev = document.querySelector('.js-letters-prev');
        const lettersCurrentPage = document.querySelector('.js-letters-current');

        lettersNext?.addEventListener('click', () => toggleLetterIndexNext(lettersCurrentPage, lettersPrev, lettersNext, allLetters));
        lettersPrev?.addEventListener('click', () => toggleLetterIndexPrev(lettersCurrentPage, lettersPrev, lettersNext, allLetters));
        window.addEventListener('resize', () => toggleLetterIndexLayout(allLetters));
    }

    initLetterIndexDropdown();
    initLetterIndexNavigation();
}

window.addEventListener('load', letterIndex);

